import React from "react";

const ExperienceContext = React.createContext({
  isInStore: false,
  isEmbedded: false
});

export const ExperienceProvider = ExperienceContext.Provider;
export const ExperienceConsumer = ExperienceContext.Consumer;


// WEBPACK FOOTER //
// ./src/providers/ExperienceContext.js